import { Produtos } from '../../contentsys-components';
import React from 'react';
import { useAxios } from '../../hooks';

import {Col, Row, Typography} from 'antd';

const { FiltroProdutos, AcoesCrudProduto, TabelaProdutos, GestaoProdutosWrapper } = Produtos;



const PaginaProdutos = () => {

    const {getApiEmitirNotas} = useAxios();
    return <GestaoProdutosWrapper>
        <Row style={{textAlign: "left"}}>
            <Col span={24} style={{padding: "10px"}}>
                <Typography.Title style={{textAlign: "left"}} level={4} >Produtos</Typography.Title>
            </Col>
        </Row>
        <Row style={{textAlign: "left"}}>
            <Col span={24} style={{padding: "0 10px"}}>

                <FiltroProdutos getApi={getApiEmitirNotas}></FiltroProdutos>
            </Col>
            <Col span={24} style={{padding: "0 10px"}}>

                <AcoesCrudProduto getApi={getApiEmitirNotas} ></AcoesCrudProduto>
            </Col>
            <Col span={24}>
                <TabelaProdutos getApi={getApiEmitirNotas}></TabelaProdutos>
            </Col>

        </Row>
    </GestaoProdutosWrapper>
}

export { PaginaProdutos }